import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {setMaterialsPageActiveSubStep} from "../../actions/selectionFunctions";

const SelectionFooterSubSteps = (props) => {

  const {isActive, activeSubPart, wizardConfig, activeSubStep, setMaterialsPageActiveSubStep} = props;

  const existingWizSetup = wizardConfig.find(wizObject => {
    return wizObject.featureGroupName === activeSubPart.part.dbName || wizObject.featureGroupName === activeSubPart.part.partName
  })

  if (!existingWizSetup || !existingWizSetup.filterGroups.length || !existingWizSetup.enableForQuoting) {
    return null
  }

  const handleSubStepClick = (index) => {
    if (index !== activeSubStep) {
      setMaterialsPageActiveSubStep(index)
    }
  }

  const currentSteps = existingWizSetup.isFinished ? [] : existingWizSetup.filterGroups;
  const width = currentSteps.length * 100;
  const style = {
    width,
    flex: "0 0 " + width + "px"
  };

  return (
    <ul className={"sub-steps" + (!isActive ? " sub-steps--hidden" : "")} style={style}>
      {currentSteps.map((filterGroup, subStepIndex) => {
        return (
          <li className={"sub-steps-item" + (subStepIndex === activeSubStep ? " sub-steps-item--active" : "")}
              key={subStepIndex} onClick={() => handleSubStepClick(subStepIndex)}>
            {/*<span className="sub-steps-item__text">{Math.ceil(subStep.length)}</span>*/}
            <span className="sub-steps-item__text">{filterGroup.name}</span>
          </li>
        )
      })}
    </ul>
  )
}

SelectionFooterSubSteps.propTypes = {
  isActive: PropTypes.bool.isRequired,
  activeSubPart: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => {
  const {wizardConfig} = store.wizardState;
  const {activeSubStep} = store.selectionState;
  return {
    wizardConfig,
    activeSubStep,
  };
};

const mapDispathToProps = {
  setMaterialsPageActiveSubStep
}

export default connect(mapStateToProps, mapDispathToProps)(SelectionFooterSubSteps);
